import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelSelect as _vModelSelect, vModelText as _vModelText, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container mt-4" }
const _hoisted_2 = { id: "contactsForm" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-6" }
const _hoisted_5 = { class: "col-md-6" }
const _hoisted_6 = { class: "card mb-3" }
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-12" }
const _hoisted_10 = { class: "d-inline-block border-start border-end border-1 p-2" }
const _hoisted_11 = { class: "form-check" }
const _hoisted_12 = {
  class: "d-inline-block border-start border-end border-1 p-2",
  style: {"padding-top":"0 !important","padding-bottom":"0 !important"}
}
const _hoisted_13 = { class: "d-inline-block" }
const _hoisted_14 = { class: "d-inline-block border-start border-end border-1 p-2" }
const _hoisted_15 = { class: "form-check" }
const _hoisted_16 = { class: "d-inline-block border-start border-end border-1 p-2" }
const _hoisted_17 = { class: "form-check" }
const _hoisted_18 = {
  class: "d-inline-block border-start border-end border-1 p-2",
  style: {"padding-top":"0 !important","padding-bottom":"0 !important"}
}
const _hoisted_19 = { class: "d-inline-block" }
const _hoisted_20 = { class: "text-center mb-3" }
const _hoisted_21 = { class: "form-check d-inline-block mb-3" }
const _hoisted_22 = { class: "text-center mb-3" }
const _hoisted_23 = ["disabled"]

import { ref, computed, inject } from 'vue';
    import type * as signalR from '@microsoft/signalr';
    import type * as types from '../types/migration';
    import FeedbackModal from './FeedbackModal.vue';
    import ServerCredentialCard from './ServerCredentialCard.vue';
    import type { AuthState, AuthMethods } from '../composables/useAuth';
    import { AUTH_STATE_KEY, AUTH_METHODS_KEY } from '../composables/authKeys';

    interface Props {
        connection: signalR.HubConnection;
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ContactsApp',
  props: {
    connection: {}
  },
  setup(__props: any) {

    const props = __props;

    const authState = inject(AUTH_STATE_KEY) as AuthState;
    const authMethods = inject(AUTH_METHODS_KEY) as AuthMethods;

    const duplicateHandling = ref<string>('Skip');
    const deleteSource = ref<boolean>(false);
    const importCollectedContacts = ref<boolean>(false);
    const importFolderName = ref<string>('');
    const progressUpdates = ref<boolean>(true);
    const tosAccepted = ref<boolean>(false);

    const feedbackModal = ref<InstanceType<typeof FeedbackModal> | null>(null);

    const isSourceAuthenticated = computed(() => {
        if (authState.sourceServerType.value !== 'NextCloud') {
            return !!authState.sourceOAuthToken.value;
        } else {
            return authState.sourceAuthSuccess.value;
        }
    });

    const isDestAuthenticated = computed(() => {
        if (authState.destServerType.value !== 'NextCloud') {
            return !!authState.destOAuthToken.value;
        } else {
            return authState.destAuthSuccess.value;
        }
    });

    const canStartMigration = computed(() => {
        return isSourceAuthenticated.value && isDestAuthenticated.value && tosAccepted.value;
    });

    function handleAuthError(title: string, message: string) {
        feedbackModal.value?.alert({
            title,
            message,
            iconClass: 'x-circle'
        });
    }

    function startMigration() {
        if (!tosAccepted.value) {
            feedbackModal.value?.alert({
                title: 'Terms of Service',
                message: 'Please accept the Terms of Service before starting migration',
                iconClass: 'exclamation-triangle'
            });
            return;
        }

        const isSourceNextCloud = authState.sourceServerType.value === 'NextCloud';
        const isDestNextCloud = authState.destServerType.value === 'NextCloud';

        const sourceCredentials: types.Creds = {
            server: authState.sourceServer.value,
            user: authState.sourceUser.value,
            password: isSourceNextCloud ? authState.sourcePassword.value : '',
            oAuthToken: !isSourceNextCloud ? authState.sourceOAuthToken.value : null,
            useOAuth: !isSourceNextCloud,
            implementer: authState.sourceServerType.value
        };

        const destinationCredentials: types.Creds = {
            server: authState.destServer.value,
            user: authState.destUser.value,
            password: isDestNextCloud ? authState.destPassword.value : '',
            oAuthToken: !isDestNextCloud ? authState.destOAuthToken.value : null,
            useOAuth: !isDestNextCloud,
            implementer: authState.destServerType.value
        };

        const options: types.ContactMoverOptions = {
            duplicateHandling: duplicateHandling.value,
            deleteSource: deleteSource.value,
            importFolderName: importFolderName.value,
            importCollectedContacts: importCollectedContacts.value
        };

        const request: types.MigrationRequest = {
            $type: 'Contact',
            sourceCredentials: sourceCredentials,
            destinationCredentials: destinationCredentials,
            options: options,
            progressUpdates: progressUpdates.value
        };

        props.connection.invoke('StartMigration', request).catch((err: Error) => {
            console.error(err.toString());
            feedbackModal.value?.alert({
                title: 'Error',
                message: 'Error starting migration: ' + err.toString(),
                iconClass: 'x-circle'
            });
        });

        console.log('Starting contact migration...');
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[17] || (_cache[17] = _createElementVNode("h3", { class: "mb-4" }, "Contact Migration Tool", -1 /* CACHED */)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(ServerCredentialCard, {
              direction: "source",
              title: "Source Account",
              headerClass: "bg-primary",
              serverTypeOptions: [{value: 'NextCloud', label: 'NextCloud'}, {value: 'Google', label: 'Google'}],
              migrationType: "Contacts",
              useOAuthPredicate: (serverType) => serverType !== 'NextCloud',
              onAuthError: handleAuthError
            }, null, 8 /* PROPS */, ["useOAuthPredicate"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(ServerCredentialCard, {
              direction: "dest",
              title: "Destination Account",
              headerClass: "bg-success",
              serverTypeOptions: [{value: 'NextCloud', label: 'NextCloud'}, {value: 'Google', label: 'Google'}],
              migrationType: "Contacts",
              useOAuthPredicate: (serverType) => serverType !== 'NextCloud',
              onAuthError: handleAuthError
            }, null, 8 /* PROPS */, ["useOAuthPredicate"])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _cache[14] || (_cache[14] = _createElementVNode("div", { class: "card-header" }, [
            _createElementVNode("h5", { class: "mb-0" }, "Migration Options")
          ], -1 /* CACHED */)),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      id: "progressUpdates",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((progressUpdates).value = $event))
                    }, null, 512 /* NEED_PATCH */), [
                      [_vModelCheckbox, progressUpdates.value]
                    ]),
                    _cache[6] || (_cache[6] = _createElementVNode("label", {
                      class: "form-check-label",
                      for: "progressUpdates"
                    }, " Progress Updates ", -1 /* CACHED */))
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _cache[8] || (_cache[8] = _createElementVNode("div", { class: "d-inline-block" }, [
                    _createElementVNode("label", {
                      for: "duplicateHandling",
                      class: "form-label"
                    }, "Duplicate Handling")
                  ], -1 /* CACHED */)),
                  _cache[9] || (_cache[9] = _createElementVNode("div", { class: "d-inline-block" }, "  ", -1 /* CACHED */)),
                  _createElementVNode("div", _hoisted_13, [
                    _withDirectives(_createElementVNode("select", {
                      class: "form-select",
                      id: "duplicateHandling",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((duplicateHandling).value = $event))
                    }, [...(_cache[7] || (_cache[7] = [
                      _createElementVNode("option", { value: "Overwrite" }, "Overwrite", -1 /* CACHED */),
                      _createElementVNode("option", { value: "Skip" }, "Skip", -1 /* CACHED */),
                      _createElementVNode("option", { value: "CreateDuplicate" }, "Create Duplicate", -1 /* CACHED */),
                      _createElementVNode("option", { value: "Merge" }, "Merge", -1 /* CACHED */)
                    ]))], 512 /* NEED_PATCH */), [
                      [_vModelSelect, duplicateHandling.value]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      id: "deleteSource",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((deleteSource).value = $event))
                    }, null, 512 /* NEED_PATCH */), [
                      [_vModelCheckbox, deleteSource.value]
                    ]),
                    _cache[10] || (_cache[10] = _createElementVNode("label", {
                      class: "form-check-label",
                      for: "deleteSource"
                    }, " Delete Source ", -1 /* CACHED */))
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      id: "importCollectedContacts",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((importCollectedContacts).value = $event))
                    }, null, 512 /* NEED_PATCH */), [
                      [_vModelCheckbox, importCollectedContacts.value]
                    ]),
                    _cache[11] || (_cache[11] = _createElementVNode("label", {
                      class: "form-check-label",
                      for: "importCollectedContacts"
                    }, " Import Collected Contacts ", -1 /* CACHED */))
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _cache[12] || (_cache[12] = _createElementVNode("div", { class: "d-inline-block" }, [
                    _createElementVNode("label", {
                      for: "importFolderName",
                      class: "form-label"
                    }, "Import Folder Name")
                  ], -1 /* CACHED */)),
                  _cache[13] || (_cache[13] = _createElementVNode("div", { class: "d-inline-block" }, "  ", -1 /* CACHED */)),
                  _createElementVNode("div", _hoisted_19, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      id: "importFolderName",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((importFolderName).value = $event))
                    }, null, 512 /* NEED_PATCH */), [
                      [_vModelText, importFolderName.value]
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _withDirectives(_createElementVNode("input", {
              class: "form-check-input",
              type: "checkbox",
              id: "tosCheckbox",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((tosAccepted).value = $event))
            }, null, 512 /* NEED_PATCH */), [
              [_vModelCheckbox, tosAccepted.value]
            ]),
            _cache[15] || (_cache[15] = _createElementVNode("label", {
              class: "form-check-label",
              for: "tosCheckbox"
            }, [
              _createTextVNode(" I agree to the "),
              _createElementVNode("a", {
                href: "/Tos",
                target: "_blank"
              }, "Terms of Service")
            ], -1 /* CACHED */))
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("button", {
            id: "migrateBtn",
            class: "btn btn-primary btn-lg",
            onClick: startMigration,
            disabled: !canStartMigration.value
          }, [...(_cache[16] || (_cache[16] = [
            _createElementVNode("i", { class: "bi bi-arrow-left-right" }, null, -1 /* CACHED */),
            _createTextVNode(" Migrate Contacts ", -1 /* CACHED */)
          ]))], 8 /* PROPS */, _hoisted_23)
        ])
      ])
    ]),
    _createVNode(FeedbackModal, {
      ref_key: "feedbackModal",
      ref: feedbackModal
    }, null, 512 /* NEED_PATCH */)
  ], 64 /* STABLE_FRAGMENT */))
}
}

})